<template>
	<div class="pd-20-16 box-s">
    <ul>
			<li class="list_every pd-16-18 box-s mb-16 pra_every" v-for="(item, index) in list" :key="index">
        <div class="flexs flex-jus">
					<div class="flexs">
            <img class="wh_46 b-radius-50 mr-10" src="../../assets/img/icon/practicelist_icon.png" alt="">

						<div class="fw-500 fz-16 c1">{{item.daily_study_type == 1?'每日一练':'每日一练-加强练习'}}</div>
					</div>
          <!-- //c10 -->
					<div class="flexs bg_ec whl-74-24 flex-center fw-500 fz-12 b-radius-12 c0" @click="lookPractice(item.id)"> 
						答题报告
						<img class="wh_4_6 ml-5" src="../../assets/img/icon/blue_right_arrow.png" alt="">
					</div>
				</div>

				<div class="fw-500 fz-14 c1 pd-16 box-s bg_f9 b-radius-6 mtb-16">题目数量： {{item.question_number}}题</div>

				<div class="flex1 pl-14 box-s">
          <div class="mb-14 fz-12 c1">练习时间</div>
          <div class="fz-14 c3">{{item.time}}</div>
        </div>
			</li>
		</ul>

		<noData v-if="show"></noData>
		<loading :loadFlag="loadFlag"></loading>
	</div>
</template>
<script>

	import { getHistoryDailyStudy } from '@/api/api'
	import { formatTime } from '@/utils/common'
	import loading from "@/components/loading"
	import noData from "@/components/noData"
	export default {
		components: {
			loading,
			noData
		},
		data() {
			return {
			  list: [],
				show: false,
				loadFlag: false
			};
		},
		created() {
      this.initData()
		},
		mounted(){
		},
		methods: {
			async initData(){
				this.loadFlag = true
        const res = await getHistoryDailyStudy()
				this.loadFlag = false
				if(res.code == 1000){
          this.list = res.data
          this.list.forEach(item => {
						item.time = formatTime(Number(item.start_time + '000'), 4)
					})
					if(this.list.length == 0){
						this.show = true
					}
				} else {
            this.$toast(res.msg)
          }
			},


			lookPractice(id){
				this.$router.push({ path: '/report', query: { dailyStudyId: id } })
			}

		}
	};
</script>
<style lang="less" scoped>

.orange_sty {
	background: #FFF4EA;
	color: #FFAB5A;
}

.cf {
	color: #497CFF !important;
	box-shadow: 0px 2px 4px 0px rgba(255, 255, 255, 1);
}

.pra_every:last-child {
	margin-bottom: 0;
}
</style>
